<template>
  <div class="curated-hotel-card" @click="handleClick">
    <div class="hotel-image-wrap">
      <img
        class="hotel-image"
        :src="$optimizeQiniuImage(hotel?.images?.[0], 2)"
        :alt="hotel?.name || ''"
      />
      <div class="hotel-image-mask" />
      <img v-if="bannerLogo" class="hotel-logo" :src="bannerLogo" alt="" />
    </div>
    <div class="hotel-info">
      <UIText type="title" class="hotel-name">{{ hotel?.name }}</UIText>
      <UIText v-if="location" class="hotel-location">{{ location }}</UIText>
      <div v-if="benefitTags.length" class="benefit-tags">
        <img
          v-for="tag in benefitTags"
          :key="tag"
          class="benefit-tag"
          :src="tag"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { get } from "lodash-es";
import { computed } from "vue";

import UIText from "../UiText/index.vue";

// HoteLux 首页卡片专用的权益角标，仅本组件使用，不影响公共 HotelCard
const BENEFIT_TAG_ICONS = {
  luxury: "https://qiniu-uploads.charmdeer.com/hotelux_benefits.png",
  virtuoso: "https://qiniu-uploads.charmdeer.com/hotelux_Virtuoso.png"
};

const props = defineProps({
  hotel: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(["select"]);

// 接口返回的 city 是服务端投影结果：{ name, country: { name } }
const location = computed(() => {
  const city = props.hotel?.city;
  if (!city) return "";

  return [city.name, city.country?.name].filter(Boolean).join(", ");
});

const bannerLogo = computed(() => {
  return props.hotel?.brand?.imageDetail?.bannerLogo || "";
});

const benefitTags = computed(() => {
  const types = get(props.hotel, "benefits", []).map(item => item.type);

  return Object.entries(BENEFIT_TAG_ICONS)
    .filter(([type]) => types.includes(type))
    .map(([, icon]) => icon);
});

const handleClick = () => {
  emit("select", props.hotel);
};

defineOptions({
  name: "CuratedHotelCard"
});
</script>

<style lang="scss" scoped>
.curated-hotel-card {
  cursor: pointer;
  background: #fff;

  .hotel-image-wrap {
    position: relative;
    // 图片悬停放大后由这层裁掉溢出
    overflow: hidden;
  }

  .hotel-image {
    display: block;
    width: 100%;
    height: 240px;
    object-fit: cover;
    // 提前提升为合成层，让放大交给 GPU 合成，避免逐帧重绘造成卡顿
    will-change: transform;
    transition: transform 400ms ease-in-out;
  }

  &:hover .hotel-image {
    transform: scale(1.06);
  }

  // 压暗图片底部，保证品牌 Logo 在浅色图片上依然清晰
  .hotel-image-mask {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 384px;
    height: 120px;
    background: linear-gradient(
      180deg,
      rgb(0 0 0 / 0%) 0%,
      rgb(0 0 0 / 70%) 100%
    );
  }

  .hotel-logo {
    position: absolute;
    bottom: 18px;
    left: 24px;
    width: 86px;
    height: 40px;
    object-fit: contain;
    object-position: left bottom;
  }

  .hotel-info {
    padding: 28px 24px;
  }

  .hotel-name {
    overflow: hidden;
    // font-family: Cormorant, var(--y-title-font), serif;
    font-size: 22px;
    font-weight: 700;
    line-height: 27px;
    color: #212223;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .hotel-location {
    display: block;
    margin-top: 8px;
    font-size: 16px;
    line-height: 20px;
    color: #757575;
  }

  .benefit-tags {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-top: 16px;
  }

  .benefit-tag {
    display: block;
    width: auto;
    height: 18px;
  }
}
</style>
